/*
 * @Author: yinbing.liu
 * @Date: 2023-09-19 15:14:42
 * @LastEditors: yinbing.liu
 * @LastEditTime: 2023-09-19 15:15:03
 * @FilePath: /fushigi/src/utils/validate.ts
 * @Description:
 */
/**
 * 判断是否是外链
 * @param {string} path
 * @returns {Boolean}
 * @author LiQingSong
 */
export const isExternal = (path: string): boolean => {
  return /^(https?:|mailto:|tel:)/.test(path)
}
